/** 値が無い時のプレースホルダ (design bg-region: 0 でなくダッシュ)。 */
export const TEMPERATURE_EMPTY = '—'

/**
 * 気温を "24.3℃" 表記にする。欠測 (null) は 0℃ と区別するため「—」。
 *
 * 需要詳細のサマリーバーと 同時同量一覧のピルバッジが同じ表記を要るので
 * models に置く。小数は backend / 気象 RPC が返した精度をそのまま出す
 * (= 実測値の丸めは行わない)。
 */
export function formatTemperature(temperature: number | null): string {
  return temperature === null ? TEMPERATURE_EMPTY : `${temperature}℃`
}
